"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var MOUSE_EVENTS = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp'];
var TOUCH_EVENTS = ['onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
var KEYBOARD_EVENTS = ['onKeyDown', 'onKeyPress', 'onKeyUp'];
var FOCUS_EVENTS = ['onFocus', 'onBlur'];
var FORM_EVENTS = ['onChange', 'onInput', 'onInvalid', 'onSubmit'];
var UI_EVENTS = ['onScroll'];
var IMAGE_EVENTS = ['onLoad', 'onError'];
var synteticEvents = MOUSE_EVENTS.concat(TOUCH_EVENTS, KEYBOARD_EVENTS, FOCUS_EVENTS, FORM_EVENTS, UI_EVENTS, IMAGE_EVENTS);
var _default = synteticEvents;
exports.default = _default;